import React, { useState } from 'react';
import { api } from '../../apiConfig';
import { copyText } from '../../utils/clipboard';
import './SocialComponents.css';

const ShareButton = ({ 
  itemId, 
  itemType, 
  title,
  description,
  imageUrl,
  url,
  size = 'medium',
  showCount = false,
  className = ''
}) => {
  const [isSharing, setIsSharing] = useState(false);
  const [copied, setCopied] = useState(false);

  // Generate share URL if not provided
  const shareUrl = url || `${window.location.origin}/${itemType}/${itemId}`;
  
  const shareData = {
    title: title || `Check out this ${itemType}`,
    text: description || `Amazing ${itemType} on Art Emerge`,
    url: shareUrl
  };

  const canUseNativeShare = navigator.share && navigator.canShare && navigator.canShare(shareData);

  const handleShare = async () => {
    if (isSharing) return;
    
    setIsSharing(true);

    try {
      let shareMethod = 'link';

      if (canUseNativeShare) {
        try {
          await navigator.share(shareData);
          shareMethod = 'native';
        } catch (error) {
          if (error.name !== 'AbortError') {
            // User cancelled, fallback to copy
            await copyToClipboard();
            shareMethod = 'link';
          } else {
            return; // User cancelled
          }
        }
      } else {
        await copyToClipboard();
        shareMethod = 'link';
      }

      // Record the share
      await api.post('/social/share', {
        itemId,
        itemType,
        shareMethod
      });

    } catch (error) {
      console.error('Error sharing:', error);
    } finally {
      setIsSharing(false);
    }
  };

  const copyToClipboard = async () => {
    try {
      await copyText(shareUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      console.error('Failed to copy to clipboard:', error);
    }
  };

  const sizeClass = `share-button--${size}`;
  const loadingClass = isSharing ? 'share-button--loading' : '';
  const copiedClass = copied ? 'share-button--copied' : '';

  return (
    <button
      className={`share-button ${sizeClass} ${loadingClass} ${copiedClass} ${className}`}
      onClick={handleShare}
      disabled={isSharing}
      aria-label={`Share this ${itemType}`}
      title={canUseNativeShare ? 'Share' : 'Copy link'}
    >
      <span className="share-button__icon" aria-hidden="true">
        {copied ? '✓' : '📤'}
      </span>
      <span className="share-button__text">
        {copied ? 'Copied!' : (canUseNativeShare ? 'Share' : 'Copy link')}
      </span>
      {isSharing && <span className="share-button__spinner" aria-hidden="true"></span>}
    </button>
  );
};

export default ShareButton; 